// extracted by mini-css-extract-plugin
export var copyIcon = "_xw-2";
export var discountCard = "_xw-0";
export var discountCode = "_xw-3";
export var discountContent = "_xw-1";
export var loadingCard = "_xw-4";